import { Link } from "react-router-dom";
import { Spark } from "@/components/viz/Spark";

const nf = (x: number) => (Math.abs(x ?? 0) >= 100000
  ? Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 }).format(x)
  : Intl.NumberFormat("id-ID").format(x ?? 0));

/** Kartu angka: label, nilai besar, tren vs periode sebelumnya, sparkline konteks.
 *  goodWhenUp=false berarti naik itu buruk (mis. volume negatif) -> warna dibalik. */
export function Stat({ label, dot, icon, tint, value, sub, deltaPct, goodWhenUp = true, spark, sparkColor, href }: {
  label: string; dot?: string; icon?: string; tint?: string; value: number | string; sub?: string;
  deltaPct?: number | null; goodWhenUp?: boolean; spark?: number[]; sparkColor?: string; href?: string;
}) {
  const dir = deltaPct == null || Math.abs(deltaPct) < 0.5 ? null : deltaPct > 0 ? "up" : "down";
  const inner = (
    <>
      <span className="avio-stat__label">
        {icon && (
          <span className="avio-stat__ico" style={tint ? { background: `color-mix(in srgb, ${tint} 12%, #fff)`, color: tint } : undefined}>
            <i className={icon} />
          </span>
        )}
        {!icon && dot && <span className="avio-stat__dot" style={{ background: dot }} />}
        {label}
      </span>
      <span className="avio-stat__row">
        <span className="avio-stat__value">{typeof value === "number" ? nf(value) : value}</span>
        {spark && spark.length > 1 && <span className="avio-stat__spark"><Spark data={spark} color={sparkColor} /></span>}
      </span>
      <span className="avio-stat__foot">
        {dir && (
          <span className="avio-trend" data-dir={dir} data-good={goodWhenUp ? "true" : "false"}>
            <i className={dir === "up" ? "fa-solid fa-arrow-trend-up" : dir === "down" ? "fa-solid fa-arrow-trend-down" : "fa-solid fa-minus"} />
            {Math.abs(deltaPct!).toFixed(0)}%
          </span>
        )}
        {sub && <span>{sub}</span>}
      </span>
    </>
  );
  return href ? <Link to={href} className="avio-stat">{inner}</Link> : <div className="avio-stat">{inner}</div>;
}
